import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { RetreatsWidget } from './RetreatsWidget'

class HoldstyringRetreatsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return RetreatsWidget
  }

  // Supported HTML attributes:
  //   compact="true"  — mindre kort (billede, dato, titel, pris), så 8-12 events står pr. side
  //                     uden lang scroll (default: store kort som hidtil)
  //   page-size="12"  — vis kun så mange ad gangen og en «Vis flere»-knap (default: alle;
  //                     i kompakt visning 12)
  protected getWidgetProps() {
    const size = parseInt(this.getAttribute('page-size') || '', 10)
    return {
      compact: this.getAttribute('compact') === 'true',
      pageSize: Number.isFinite(size) && size > 0 ? Math.min(size, 100) : null,
    }
  }
}

if (!customElements.get('holdstyring-retreats')) {
  customElements.define('holdstyring-retreats', HoldstyringRetreatsElement)
}

export { HoldstyringRetreatsElement }
